export default __webpack_public_path__ + "static/media/3.3ef70002.jpg";